import { type FC, useId } from 'react';
import {
  MEETING_ACCESS_POLICY_OPTIONS,
  MEETING_ACCESS_POLICY_TITLE,
  type MeetingTypeVariant,
} from '../../../../utils/meetingAccessPolicy';
import type { SecuritySectionProps } from '../../types';

const SecuritySection: FC<SecuritySectionProps> = ({ formData, onInputChange }) => {
  const id = useId();
  const meetingSecurityLabelId = `${id}-label`;

  const handleMeetingTypeChange = (type: MeetingTypeVariant) => {
    onInputChange('meetingType', type);
  };

  return (
    <>
      <div className="schedule-meeting-modal__divider" />
      <div className="schedule-meeting-modal__security-section">
        <div
          role="radiogroup"
          className="schedule-meeting-modal__radio-group"
          aria-labelledby={meetingSecurityLabelId}
        >
          <div className="schedule-meeting-modal__input-label" id={meetingSecurityLabelId}>
            {MEETING_ACCESS_POLICY_TITLE}
          </div>

          {MEETING_ACCESS_POLICY_OPTIONS.map(({ type, label, description }) => {
            const optionId = `${id}-${type}`;
            return (
              <div key={type}>
                <div className="schedule-meeting-modal__radio-option">
                  <input
                    type="radio"
                    id={optionId}
                    name="meeting-type"
                    className="schedule-meeting-modal__radio-input"
                    checked={formData.meetingType === type}
                    onChange={() => handleMeetingTypeChange(type)}
                  />
                  <label
                    htmlFor={optionId}
                    className="schedule-meeting-modal__radio-label schedule-meeting-modal__radio-label--bold"
                  >
                    {label}
                  </label>
                </div>
                <div className="schedule-meeting-modal__radio-sublabel">{description}</div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SecuritySection;
